import React, { useCallback } from 'react';
import { useGetChangelogQuery, useRestoreSkuRedistributionMutation } from '../apiCalculationEdit';
import { Button, Column, Row } from '@ydistri/ds';
import { addToast } from '@ydistri/utils';
import { problemMessagesOf } from '../../../Configuration/Validator/problemsLib';
import { useAppDispatch } from '../../../../store';
import { RoutingPage } from '../../../../routes/routerSlice';
import { useNavigate } from 'react-router';
import { useStableParams } from '../../../../routes/useStableParams';
import { closeModal } from '../../../Modals/modalSlice';
import { useCalculationEdit } from '../useCalculationEdit';
import { Popover } from 'antd';
import ChangelogSection from './components/ChangelogSection';

interface SkuRedistributionChangelogProps {
  calculationId: number;
}

const SkuRedistributionChangelog: React.FC<SkuRedistributionChangelogProps> = ({
  calculationId,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { projectShortName } = useStableParams();
  const { data: changelogData, isFetching } = useGetChangelogQuery(calculationId);
  const { disabledRestoreTooltipMessage, isSuperUser } = useCalculationEdit(calculationId);
  const [restoreSkuRedistribution, { isLoading }] = useRestoreSkuRedistributionMutation();

  const restoreHandler = useCallback(() => {
    restoreSkuRedistribution(calculationId)
      .unwrap()
      .then(() => {
        dispatch(addToast({ message: `Restore of Calculation ${calculationId} was initialized` }));
        dispatch(closeModal());
        navigate(`/${projectShortName}/${RoutingPage.CALCULATIONS}`);
      })
      .catch((error: unknown) => {
        dispatch(
          addToast({
            message: problemMessagesOf(error, 'Calculation was not restored'),
            isError: true,
          }),
        );
      });
  }, [restoreSkuRedistribution, calculationId, dispatch, navigate, projectShortName]);

  return (
    <Column $gap="2rem">
      <Column $gap="0.75rem">
        {changelogData?.map(item => (
          <ChangelogSection key={item.skuRedistributionChangelogId} item={item} />
        ))}
      </Column>
      {isSuperUser && (
        <Row $gap="1rem" $alignItems="center" $justifyContent="start">
          You can revert all the changes:
          <Popover content={disabledRestoreTooltipMessage}>
            <Button
              loading={isLoading}
              onClick={restoreHandler}
              disabled={isLoading || isFetching || disabledRestoreTooltipMessage !== undefined}
            >
              Restore calculation
            </Button>
          </Popover>
        </Row>
      )}
    </Column>
  );
};

export default SkuRedistributionChangelog;
